<template>
  <div class="datetime-form_box">
    <template v-if="isVisibleYear">
      <select class="select_form" v-model="datetimeValues.year" @change="modify">
        <option v-for="year in getYears" :key="year" :value="year">{{ year }}</option>
      </select>
      <label>年</label>
    </template>

    <template v-if="isVisibleMonth">
      <select class="select_form" v-model="datetimeValues.month" @change="modify">
        <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
      </select>
      <label>月</label>
    </template>

    <template v-if="isVisibleDate">
      <select class="select_form" v-model="datetimeValues.date">
        <option v-for="date in getDates" :key="date" :value="date">{{ date }}</option>
      </select>
      <label>日</label>
    </template>

    <template v-if="isVisibleHour">
      <select class="select_form" v-model="datetimeValues.hour">
        <option v-for="hour in hours" :key="hour" :value="hour">{{ hour }}</option>
      </select>
      <label>時</label>
    </template>

    <template v-if="isVisibleMinute">
      <select class="select_form" v-model="datetimeValues.minute">
        <option v-for="minute in minutes" :key="minute" :value="minute">{{ minute }}</option>
      </select>
      <label>分</label>
    </template>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: "DatetimeFormBlock",

    props: {
      value: {
        required: true
      },
      defaultValue: {
        required: false
      },
      isVisibleYear: {
        type: Boolean,
      },
      isVisibleMonth: {
        type: Boolean,
      },
      isVisibleDate: {
        type: Boolean,
      },
      isVisibleHour: {
        type: Boolean,
      },
      isVisibleMinute: {
        type: Boolean,
      },
    },

    data() {
      return {
        months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        hours: [...Array(24).keys()],
        minutes: [0, 15, 30, 45],
        datetimeValues: {
          year: moment().year(),
          month: moment().month() + 1,
          date: moment().date(),
          hour: 0,
          minute: 0,
        },
      }
    },

    watch: {
      defaultValue: {
        handler: function () {
          if (this.defaultValue.seconds) {
            const defaultValue = moment.unix(this.defaultValue.seconds);
            this.datetimeValues.year = defaultValue.year();
            this.datetimeValues.month = defaultValue.month() + 1;
            this.datetimeValues.date = defaultValue.date();
            this.datetimeValues.hour = defaultValue.hour();
            this.datetimeValues.minute = defaultValue.minute();
          }
        }
      },
      datetimeValues: {
        handler: function () {
          let timestamp = moment([
            this.datetimeValues.year,
            this.datetimeValues.month - 1,
            this.datetimeValues.date,
            this.datetimeValues.hour,
            this.datetimeValues.minute,
          ]);
          this.$emit('input', timestamp.toDate())
        },
        deep: true
      },
    },

    computed: {
      getYears() {
        const goBackYears = 200;
        const currentYear = moment().year() + 100;
        const startYear = currentYear - goBackYears;
        return [...Array(goBackYears + 1).keys()].map(x => x + startYear);
      },

      getDates() {
        const maxDate = this.getFinalDate(this.datetimeValues.year, this.datetimeValues.month);
        return [...Array(maxDate).keys()].map(x => x + 1);
      },
    },

    methods: {
      /**
       * 年や月が変更されたとき、日が存在しなくなる場合があるので調整する。
       * 例: 2018-12-31 を選択していて月が 12 から 2 に変更された場合、日を 28 にする。
       */
      modify() {
        if (!moment([this.datetimeValues.year, this.datetimeValues.month - 1, this.datetimeValues.date]).isValid()) {
          this.datetimeValues.date = this.getFinalDate(this.datetimeValues.year, this.datetimeValues.month);
        }
      },

      getFinalDate(year, month) {
        return moment([year, month - 1]).endOf('month').date();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .datetime-form_box {
    .select_form {
      margin: 0 1rem;
    }
  }
</style>